/**
 * Shuffles array in place.
 * @param {Array} a items An array containing the items.
 */
export const shuffle = <T>(arr: T[]): T[] => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = arr[i]
    arr[i] = arr[j]
    arr[j] = temp
  }
  return arr
}

export const removeDuplicates = (arr: (string | undefined | null)[]): string[] => {
  return Array.from(new Set(arr.filter((tag) => tag != null).map((tag) => tag!.toUpperCase())))
}
